import { Injectable } from "@angular/core";
import { Adapter } from "src/app/adapter";
import * as moment from "moment";

export class UserDefinedCodes {
  constructor(
    public id: number,
    public key1: string,
    public key2: string,
    public parentValue: string,
    public childValue: string,
    public labelText: string,
    public pdText1: string,
    public pdText2: string,
    public pdText3: string,
    public pdText4: string,
    public pdText5: string,
    public pdFlag1: string,
    public pdFlag2: string,
    public pdFlag3: string,
    public pdFlag4: string,
    public pdFlag5: string,
    public ssrsUrl: string,
    public rptTitle: string,
    public rptDesc: string,
    public visible: string,
    public editable: string,
    public changeID: string,
    public lastUpdated: moment.Moment
  ) {}
}

@Injectable({
  providedIn: "root"
})
export class UserDefinedCodesAdapter implements Adapter<UserDefinedCodes> {
  adapt(item: any): UserDefinedCodes {
    return new UserDefinedCodes(
      item.TPROWID,
      item.TPKEY1,
      item.TPKEY2,
      item.TPPARENTVALUE,
      item.TPCHILDVALUE,
      item.TPLABELTEXT,
      item.TPPDTEXT1,
      item.TPPDTEXT2,
      item.TPPDTEXT3,
      item.TPPDTEXT4,
      item.TPPDTEXT5,
      item.TPPDFLAG1,
      item.TPPDFLAG2,
      item.TPPDFLAG3,
      item.TPPDFLAG4,
      item.TPPDFLAG5,
      item.TPSSRSURL,
      item.TPRPTTITLE,
      item.TPRPTDESC,
      item.TPVISIBLE,
      item.TPEDITABLE,
      item.TPCHANGEID,
      item.TPLASTUPDATED
    );
  }
}
